export default {
  version: 'master',
  compilation: '212807'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1472
// module chunks = 22